// sms: links that pre-fill the message on both iOS ("?&body=") and Android ("?body=").
export const smsHref = (phone, body = "") =>
  `sms:${(phone || "").replace(/[^\d+]/g, "")}${body ? `?&body=${encodeURIComponent(body)}` : ""}`;

const firstName = (name) => (name || "").trim().split(/\s+/)[0] || "there";

// "Hi Dana, Brioni Granite here — re: PO PO-1013 (MSI). "
export const repText = (rep, company, po) =>
  `Hi ${firstName(rep?.rep_name)}, ${company || "we"} here — ${
    po?.code ? `re: PO ${po.code}${rep?.name ? ` (${rep.name})` : ""}. ` : ""
  }`;

const prettyTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  return `${((h + 11) % 12) + 1}${m ? `:${String(m).padStart(2, "0")}` : ""} ${suffix}`;
};

// "Hi Jane, Brioni Granite here — we can show you Taj Mahal on 2026-06-12 at 2 PM at Brioni Granite. Reply YES to confirm."
export const viewingText = (name, company, item, date, time, where) =>
  `Hi ${firstName(name)}, ${company || "we"} here — we can show you ${item || "the slab"}${
    date ? ` on ${date}` : ""
  }${time ? ` at ${prettyTime(time)}` : ""}${where ? ` at ${where}` : ""}. Reply YES to confirm.`;
